export const POPUP_DETAIL_PROFILE_EVENTS = {
  SELECT_SHARE_STORE: "web_select_share_store",
  SELECT_CONTACT_VENDOR: "web_select_contact_vendor",
  SELECT_PLAY_STORE_VIDEO: "web_select_play_store_video",
};
